$(window).on("load", function () {
  if ($(".resultats").length) {
    $(".slider-product-images").slick({
      infinite: true,
      arrows: true,
      variableWidth: false,
      slidesToShow: 1,
      dots: true,
      nextArrow: ".images--right",
      asNavFor: ".slider-products-content",
    });
    $(".slider-products-content").slick({
      infinite: true,
      arrows: false,
      variableWidth: false,
      slidesToShow: 1,
      dots: false,
      fade: true
    });

  }
});
